import React, { useEffect, useState } from "react";
import ModulePage from "@/components/ModulePage";
import { api } from "@/lib/api";

const columns = [
  { key: "account_id", label: "Account ID", mono: true },
  { key: "marketplace", label: "Marketplace" },
  { key: "account_type", label: "Account Type" },
  { key: "warehouse_name", label: "Warehouse", mono: true },
  { key: "company_name", label: "Company" },
  { key: "email", label: "Email" },
  { key: "phone_no", label: "Phone" },
  { key: "merchant_token", label: "Merchant Token", mono: true,
    formatter: (r) => r.merchant_token ? `${String(r.merchant_token).slice(0, 8)}…` : "—" },
  { key: "tags", label: "Tags" },
];

export default function Accounts() {
  const [warehouses, setWarehouses] = useState([]);
  useEffect(() => {
    api.get("/warehouse").then((r) => setWarehouses(r.data || [])).catch(() => {});
  }, []);

  const fields = [
    { key: "account_id", label: "Account ID" },
    { key: "marketplace", label: "Marketplace", type: "select", options: ({ dropdowns }) => dropdowns.marketplace || [] },
    { key: "account_type", label: "Account Type", type: "select", options: ({ dropdowns }) => dropdowns.account_type || [] },
    { key: "warehouse_name", label: "Warehouse", type: "select", options: () => warehouses.map((w) => w.name) },
    { key: "merchant_token", label: "Merchant Token", span: 2 },
    { key: "company_name", label: "Company Name" },
    { key: "email", label: "Email" },
    { key: "phone_no", label: "Phone No" },
    { key: "tags", label: "Tags" },
  ];

  return (
    <ModulePage
      moduleKey="accounts"
      title="Accounts"
      subtitle="Marketplace seller accounts • Warehouse allocation drives per-account stock deduction"
      columns={columns}
      fields={fields}
      filterFields={["account_id", "marketplace", "account_type", "warehouse_name", "company_name", "email", "tags"]}
    />
  );
}
